import { createContext } from "react";

import { UserOnlineBookingProfileFormHelper } from "./UserOnlineBookingProfileFormHelper.ts";

export const UserOnlineBookingProfileFormContext =
  createContext<UserOnlineBookingProfileFormHelper>(
    {} as UserOnlineBookingProfileFormHelper
  );
